import React, { useEffect, useState } from "react";

const RenderMultiSelect = (props: any) => {
    const [options, setOptions] = useState([] as any);

    const onChange = (option: any) => {
        var tempOptions = [] as any;
        var answers = [] as any;
        options.forEach((opt: any) => {
            if (opt.option === option) {
                opt.checked = !opt.checked;
            }
            if (opt.checked) {
                answers.push(opt.option);
            }
            tempOptions.push(opt);
        });
        setOptions(tempOptions);
        props.onChange(answers);
    };

    const prepareOptions = () => {
        var arrOpt = [] as any;

        props.answerList.forEach((option: any) => {
            var opt = { option: option, checked: false };

            props.answer?.forEach((ans: any) => {
                if (option === ans) {
                    opt.checked = true;
                }
            });
            arrOpt.push(opt);
        });

        setOptions(arrOpt);
    };

    useEffect(() => {
        prepareOptions();
    }, []);

    return (
        <React.Fragment>
            <div className="form-row row">
                <div className="col-xs-12 col-no-gutter">
                    <legend className="legend-label"> {props.Title}</legend>
                </div>

                <div className="col-xs-12 col-no-gutter">
                    <div className="row">
                        {options.map((option: any, index: number) => (
                            <div key={`option-${option.option}-${index}`} className="col-xs-12 col-no-gutter">
                                <div className="form-row no-margin">
                                    <div className="form-input">
                                        <label className="form-checkbox-label"  >
                                            <input type="checkbox" id={`legend-label-${props.id}-${index}`} name={option.option} onClick={(e: any) => onChange(option.option)} />
                                            <span className="form-checkbox-label-text">{option.option}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default RenderMultiSelect;
